import { useState } from "react";
import LeadDialog from "./LeadDialog";
import { Autocomplete, TextField } from "@mui/material";
import { handleValidateCodevalue } from "../Utility/constant";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { createRequestData } from "../Utility/apiHelper";

import { requestHideLoader, requestShowLoader } from "../Store/Global/action";
const SendNotification = ({
  open,
  title,
  dataGridData,
  selectedDetails,
  setIsOpenNotificationDialog,
  type,
}) => {
  const internationalise = useSelector(
    state => state?.internationalise?.currentHashMapData
  );
  const { enqueueSnackbar } = useSnackbar();
  const [selectedtemplate,setSelectedTemplate] = useState()
  const [requiredError,setRequiredError] = useState(false)
  const dispatch = useDispatch()
    const handleSelectTemplate = async (e,val)=>{
        setSelectedTemplate(val)
    }

  const handleSend = async () => {
    if (!selectedtemplate) {
      setRequiredError(true)
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "SELECT_TEMPLATE_WARNING"),
        { variant: "warning" }
      );
      return;
    }

    const payload = {
      receipentList: selectedDetails,
      emailSubject: selectedtemplate?.subject,
      templateBody: selectedtemplate?.templateBody,
      document_id: selectedtemplate?.document_id,
      templateId: selectedtemplate?.id,
      type,
    };
    const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/send-bulk-email`
    try {
      dispatch(requestShowLoader())
      const response = await createRequestData(payload,url);

    if (response?.status === 200) {
          enqueueSnackbar(handleValidateCodevalue(internationalise, response?.data),{ variant: "success" });
        } else {
          enqueueSnackbar(handleValidateCodevalue(internationalise,response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN"),{ variant: "error" });
        }
        handleClose();
      } catch (err) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"),{ variant: "error" });
      } finally {
        dispatch(requestHideLoader())
      }
  };
const handleClose = () =>{
setIsOpenNotificationDialog({
    required : false,
    selectedTemplate : null,
    isOpen : false,
    templates : [],
    list : [],
    selected : [],
})
}
  return (
    <LeadDialog
      open={open}
      handleClose={handleClose}
      title={title}
      size="sm"
      selectedowner
      btnlabel={handleValidateCodevalue(internationalise, "COMMON_SEND")}
      handleSave={handleSend}
    >
      <Autocomplete
        options={dataGridData}
        sx={{ width: "100%", p: 1 }}
        getOptionLabel={(option) => option?.name || ""}
        value={selectedtemplate}
        onChange={handleSelectTemplate}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            required
            error={!selectedtemplate && requiredError}
            variant="standard"
            label={handleValidateCodevalue(
              internationalise,
              "CAMP_SELECT_TEMP"
            )}
            fullWidth
          />
        )}
      />
    </LeadDialog>
  );
};

export default SendNotification;
